import * as React from "react"

import { getNavBarFromGlobal } from "../data/global"
import { getFooterFromGlobal } from "../data/global"
import { Script } from 'gatsby'

import Header from "./header"
import Footer from "./footer"
import "./style.scss"

/**
 * @param {{
 *    children: React.ReactNode,
 *    preview?: boolean,
 *    globalData: import('../data/global').Global,
 *    className?: string
 *    slug?: string
 *    path?: string
 * }} param0
 * @returns
 */
const Layout = ({ children, globalData, preview = false, ...props }) => {
	const navbar = getNavBarFromGlobal(globalData, preview)
	const footer = getFooterFromGlobal(globalData, preview)
	let isPaymentPage = typeof window !== 'undefined' && window.location.pathname.includes('payment') && !window.location.pathname.includes('paymentSuccess') ? true : false;
	const dtURL = navbar.logo?.url

	return (
		<>
			{isPaymentPage == false ? <Header navbar={navbar} preview={preview} pathName={props.path} slug={props.slug} /> :
			<header className="layout-header white"><img src={dtURL} alt={dtURL} /></header>}
			<main className={`content-area ${props?.className ?? ""}`}>
				{children}
			</main>
			{/* <!-- Start of HubSpot Embed Code --> */}
			<Script src="//js.hs-scripts.com/7162442.js" />
			{/* <!-- End of HubSpot Embed Code --> */}
			{!isPaymentPage && <Footer footer={footer}/>}
		</>
	)
}

export default Layout
